import React, { useState, useEffect } from 'react'
import {
  Menu,
  X,
  ChevronDown,
  Globe,
  CalendarCheck,
  CreditCard,
  Users,
  Code2,
  Cloud,
  Smartphone,
  ShoppingCart,
  Building2,
  Palette,
} from 'lucide-react'
import './Navbar.css'

/* Reuses the same service catalog as the Services section.
   Update titles/desc here if that list ever changes. */
const serviceItems = [
  { icon: <Globe size={18} />, title: 'Website Portfolio', desc: 'Company sites that build trust' },
  { icon: <CalendarCheck size={18} />, title: 'Booking Systems', desc: 'Reservations & scheduling' },
  { icon: <CreditCard size={18} />, title: 'POS', desc: 'Sales & inventory tracking' },
  { icon: <Users size={18} />, title: 'CRM Systems', desc: 'Leads & customer management' },
  { icon: <Code2 size={18} />, title: 'Custom Web Apps', desc: 'Built for your workflow' },
  { icon: <Cloud size={18} />, title: 'SaaS Applications', desc: 'Scalable, subscription-ready' },
]

/* Placeholder categories — swap these for your real project
   names/links once you have specific case studies to point to. */
const projectItems = [
  { icon: <Globe size={18} />, title: 'Web Applications', desc: 'React / Vite platforms' },
  { icon: <Smartphone size={18} />, title: 'Mobile Apps', desc: 'React Native / Expo' },
  { icon: <Cloud size={18} />, title: 'SaaS Platforms', desc: 'Multi-tenant products' },
  { icon: <ShoppingCart size={18} />, title: 'E-commerce', desc: 'Stores & ordering systems' },
  { icon: <Building2 size={18} />, title: 'Business Systems', desc: 'Dashboards & internal tools' },
  { icon: <Palette size={18} />, title: 'UI/UX Case Studies', desc: 'Design-led builds' },
]

export default function Navbar() {

  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const [activeMenu, setActiveMenu] = useState(null) // null | 'services' | 'projects'

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const closeMenu = () => setActiveMenu(null)

  return (
    <header className={scrolled ? 'navbar scrolled' : 'navbar'}>
      <div className="navbar-container">
        <div
          className={activeMenu ? 'nav-panel expanded' : 'nav-panel'}
          onMouseLeave={closeMenu}
        >
          <div className="nav-panel-top">

            <a href="#home" className="nav-logo" onMouseEnter={closeMenu}>
              <div className="logo-icon">
                <img src="/logo.png" alt="Maxwell Tech Logo" />
              </div>
              <span>Maxwell Tech.</span>
            </a>

            <nav className={menuOpen ? 'nav-links open' : 'nav-links'}>
              <a href="#about" onMouseEnter={closeMenu} onClick={() => setMenuOpen(false)}>
                About
              </a>

              <a
                href="#services"
                className={activeMenu === 'services' ? 'nav-trigger active' : 'nav-trigger'}
                onMouseEnter={() => setActiveMenu('services')}
                onClick={() => { setMenuOpen(false); closeMenu() }}
              >
                Services
                <ChevronDown size={15} className="nav-chevron" />
              </a>

              <a
                href="#portfolio"
                className={activeMenu === 'projects' ? 'nav-trigger active' : 'nav-trigger'}
                onMouseEnter={() => setActiveMenu('projects')}
                onClick={() => { setMenuOpen(false); closeMenu() }}
              >
                Projects
                <ChevronDown size={15} className="nav-chevron" />
              </a>

              <a href="#testimonials" onMouseEnter={closeMenu} onClick={() => setMenuOpen(false)}>
                Testimonials
              </a>
              <a
                href="#contact"
                className="nav-cta"
                onMouseEnter={closeMenu}
                onClick={() => setMenuOpen(false)}
              >
                Start a Project
              </a>
            </nav>

            <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
              {menuOpen ? <X size={22} /> : <Menu size={22} />}
            </button>

          </div>

          {/* the panel itself grows to reveal this row when a trigger is hovered */}
          <div className="nav-panel-expand">
            {activeMenu === 'services' && (
              <div className="nav-expand-grid">
                {serviceItems.map((item) => (
                  <a href="#services" className="nav-expand-item" key={item.title} onClick={closeMenu}>
                    <span className="nav-expand-icon">{item.icon}</span>
                    <span className="nav-expand-text">
                      <span className="nav-expand-title">{item.title}</span>
                      <span className="nav-expand-desc">{item.desc}</span>
                    </span>
                  </a>
                ))}
              </div>
            )}
            {activeMenu === 'projects' && (
              <div className="nav-expand-grid">
                {projectItems.map((item) => (
                  <a href="#portfolio" className="nav-expand-item" key={item.title} onClick={closeMenu}>
                    <span className="nav-expand-icon">{item.icon}</span>
                    <span className="nav-expand-text">
                      <span className="nav-expand-title">{item.title}</span>
                      <span className="nav-expand-desc">{item.desc}</span>
                    </span>
                  </a>
                ))}
              </div>
            )}
          </div>

        </div>
      </div>
    </header>
  )
}